module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.crps == 'Enrolled') ? _c('div', {
    staticClass: "alert alert-dismissible"
  }, [_c('strong', [_vm._v("Thank you for pledging to Adopt-a-School in your community! Visit the Resources Page to access our Adopt-a-School resources.")])]) : _vm._e(), _vm._v(" "), (_vm.crps == 'Declined') ? _c('div', {
    staticClass: "alert alert-dismissible"
  }, [_c('strong', [_vm._v("No problem. If you change your mind you can always learn more and pick your CLTL Day from the Resource Page.")])]) : _vm._e()])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-478b13ce", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-478b13ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CovidReliefFeedbackResultModal.vue
// module id = 497
// module chunks = 3